import React from "react";
import { FaFacebook, FaTwitter, FaInstagram, FaEnvelope, FaWhatsapp, FaArrowRight } from "react-icons/fa";
import "../../styles/transaction.css";
import { Link } from 'react-router-dom';
import "../../styles/contact/contact.css";

const Contact = () => {
    return (
        <div className="contact-container">
            <p className="contact-center">You can reach us via the following channels:</p>

            <div className="contact-methods">
                {/* Email */}
                <Link to="mailto:help@subnetexpress.com" className="contact-card">
                    <div className="contact-row">
                        <FaEnvelope className="icon" />
                        <div className="contact-info">
                            <h4>help@subnetexpress.com</h4>
                            <p>Email address</p>
                        </div>
                    </div>
                </Link>

                {/* WhatsApp */}
                <Link
                    to="https://wa.me/2347088085432"
                    className="contact-card"
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    <div className="contact-row">
                        <FaWhatsapp className="icon" />
                        <div className="contact-info">
                            <h4>WhatsApp</h4>
                            <p>Social media</p>
                        </div>
                    </div>
                </Link>

                {/* Twitter */}
                <Link to="#" className="contact-card" rel="noopener noreferrer">
                    <div className="contact-row">
                        <FaTwitter className="icon" />
                        <div className="contact-info">
                            <h4>Twitter</h4>
                            <p>Social media</p>
                        </div>
                    </div>
                </Link>

                {/* Instagram */}
                <Link to="#" className="contact-card" rel="noopener noreferrer">
                    <div className="contact-row">
                        <FaInstagram className="icon" />
                        <div className="contact-info">
                            <h4>Instagram</h4>
                            <p>Social media</p>
                        </div>
                    </div>
                </Link>
            </div>
        </div>
    );
};

export default Contact;